import { useMemo } from "react";
import { ClientPortfolioInstructionHoldingTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { COMMODITY_CODES } from "web_myplann/Portfolio/Forms/ToolsShared/constants";
import { useEnumSelectOptions } from "web_myplann/Shared/Hooks/useEnumSelectOptions";

export const useHoldingTypeOptions = () =>
	useEnumSelectOptions(
		ClientPortfolioInstructionHoldingTypeEnum,
		Resources.PortfolioDetail.ToolHistory.Cryptocurrency.HoldingType,
	);

export const useCommodityIdentificationOptions = () => {
	const { t } = useResource();

	return useMemo(
		() =>
			COMMODITY_CODES.map((code) => {
				const label = t(Resources.Portfolio.AddTools.Identification[code]);
				return { value: label, label };
			}),
		[t],
	);
};
